/* eslint-disable import/no-unused-modules */
// Export all contexts and their hooks (for future optimized usage)
export {
  FormSubmissionContext,
  type FormSubmissionContextValue,
  useFormSubmissionContext,
} from "./FormSubmitContext";

export { FormSubmissionProvider } from "./FormSubmissionProvider";

export {
  TemplateContext,
  type TemplateContextValue,
  useTemplateContext,
} from "./TemplateContext";

export {
  InitialValuesContext,
  type InitialValuesContextValue,
  useInitialValuesContext,
} from "./InitialValuesContext";

export {
  FormMethodsContext,
  type FormMethodsContextValue,
  useFormMethodsContext,
} from "./FormMethodsContext";

export {
  FieldRolloverContext,
  type FieldRolloverContextValue,
  useFieldRolloverContext,
} from "./FieldRolloverContext";

// Export main provider
export { FormEngineProvider } from "./FormEngineProvider";

// Export types
export type { TemplateTransition } from "./types";
/* eslint-enable import/no-unused-modules */
